import { render, staticRenderFns } from "./Torneos.vue?vue&type=template&id=4434eaf0&scoped=true"
import script from "./Torneos.vue?vue&type=script&lang=ts&setup=true"
export * from "./Torneos.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Torneos.vue?vue&type=style&index=0&id=4434eaf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434eaf0",
  null
  
)

export default component.exports